<template>
  <div class="Toast" v-if="showToast">{{ message }}</div>
</template>
<script>
export default {
  name: "Toast",
  props: {
    showToast: {
      // 激活
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    delay: {
      type: Number,
      default: 2500,
    },
  },
  data() {
    return {};
  },
  methods: {
    // Toast消失
    disappear() {
      if (this.showToast) {
        setTimeout(() => {
          this.$emit("disappear");
        }, this.delay);
      }
    },
  },
  watch: {
    showToast() {
      this.disappear();
    },
  },
};
</script>

<style scoped>
.Toast {
  position: fixed;
  left: 50%;
  top: 20%;
  background: rgb(225, 225, 225, .9);
  width: 7rem;
  height: 200px;
  border-radius: 100px;
  transform: translate(-50%, -50%);
  animation: show-toast 0.2s;
  color: #909399;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 100px;
}

@keyframes show-toast {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>